var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('registrations', 'Registrations')))]),_c('loader',{attrs:{"loading":_vm.isLoadingRegistrations,"message":_vm.$t('loading-registrations', 'Loading registrations...')}},[_c('data-table',{attrs:{"data":_vm.registrations,"columns":[
        {
          key: 'registrationKey',
          displayName: _vm.$t('reg-key', 'Reg. key'),
          sortable: false
        },
        {
          key: 'isEnabled',
          displayName: _vm.$t('enabled', 'Enabled'),
          sortable: true,
          editable: true,
          searchable: false
        },
        {
          key: 'isValidation',
          displayName: _vm.$t('validation', 'Validation'),
          sortable: true,
          editable: true,
          searchable: false
        },
        {
          key: 'firstRegistration',
          displayName: _vm.$t('first-reg', 'First reg.'),
          sortable: true,
          type: 'datetime'
        },
        {
          key: 'lastRegistration',
          displayName: _vm.$t('last-reg', 'Last reg.'),
          sortable: true,
          type: 'datetime'
        },
        {
          key: 'registrationIndex',
          displayName: _vm.$t('reg-idx', 'Idx'),
          sortable: true,
          textAlign: 'right',
          searchable: false
        },
        {
          key: 'isPaid',
          displayName: _vm.$t('paid', 'Paid'),
          sortable: true,
          editable: true,
          searchable: false
        },
        {
          key: 'registeredBy',
          displayName: _vm.$t('registered-by-short', 'Reg. by'),
          sortable: true
        },
        {
          key: 'isSoldByKG',
          displayName: _vm.$t('sold-by-kg', 'Sold by KG'),
          sortable: true,
          editable: true,
          searchable: false
        },
        {
          key: 'company',
          displayName: _vm.$t('company', 'Company'),
          sortable: true,
          editable: true
        },
        {
          key: 'contactPerson',
          displayName: _vm.$t('contact-person', 'Contact person'),
          sortable: true,
          editable: true
        },
        {
          key: 'email',
          displayName: 'E-mail',
          sortable: true,
          editable: true
        },
        {
          key: 'telephone',
          displayName: _vm.$t('telephone', 'Telephone'),
          editable: true,
          sortable: false
        },
        {
          key: 'comment',
          displayName: _vm.$t('comment', 'Comment'),
          editable: true
        },
        {
          key: 'isDeleted',
          displayName: _vm.$t('deleted', 'Deleted'),
          sortable: true,
          editable: true,
          searchable: false
        }
      ]},on:{"onEditRow":function($event){_vm.editRegistration = $event},"onDeleteRow":_vm.deleteRegistration},scopedSlots:_vm._u([{key:"actions",fn:function(ref){
      var row = ref.row;
return [_c('a',{attrs:{"href":"","title":_vm.$t('renew', 'Renew')},on:{"click":function($event){$event.preventDefault();return _vm.renewRegistration(row)}}},[_c('font-awesome-icon',{attrs:{"icon":"sync","fixed-width":""}})],1)]}}])})],1),(_vm.editRegistration)?_c('div',{staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background",on:{"click":function($event){_vm.editRegistration = null}}}),_c('div',{staticClass:"modal-card"},[_c('div',{staticClass:"modal-card-head"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('edit-registration', 'Edit registration')))])]),_c('div',{staticClass:"modal-card-body"},[_c('registration-form',{ref:"editRegistrationForm",attrs:{"default":_vm.editRegistration},on:{"onSubmitRegistration":_vm.updateRegistration}})],1),_c('div',{staticClass:"modal-card-foot"},[_c('div',{staticClass:"field is-grouped"},[_c('button',{staticClass:"button is-primary",on:{"click":function($event){return _vm.$refs.editRegistrationForm.submit()}}},[_vm._v(_vm._s(_vm.$t('save', 'Save')))]),_c('button',{staticClass:"button is-text",on:{"click":function($event){_vm.editRegistration = null}}},[_vm._v(_vm._s(_vm.$t('cancel', 'Cancel')))])])])])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }